import React from 'react'
import { Button } from 'spa/member/components/v2/Button'
import styles from './ServiceFeatureJobOffers.module.scss'
import { useIsMobile } from 'spa/member/hooks/v2/useScreenSize'
import { JobOffersSlider } from 'spa/member/components/Top/JobOffersSlider'
import { Accordion } from 'spa/member/components/Accordion'
import { SkillSearchLinks } from 'spa/member/components/Top/SkillSearchLinks'
import { CategorySearchLinks } from 'spa/member/components/Top/CategorySearchLinks'
import { Link } from 'react-router-dom'
import { RemoteWorkPieChart } from 'spa/member/components/Top/RemoteWorkPieChart'

export const StyledServiceFeatureJobOffers: React.FC = () => {
  const isMobile = useIsMobile()

  return (
    <section className={`border-1 border-member-gray-0 w-full rounded-L px-M py-XL tablet:px-3XL tablet:py-2XL ${styles.keyVisual}`}>
      <section className="flex gap-XL justify-center all:flex-wrap desktop:flex-nowrap desktop:gap-4XL">
        <RemoteWorkPieChart />
        <section className="flex flex-col items-center desktop:items-start">
          <header className="text-L font-bold pb-XS text-center tablet:text-2XL" style={{ lineHeight: '1.75' }}>
            90%の方が{isMobile && <br />}リモートワーク案件で稼働中
          </header>
          <p className="pb-2XS text-S tablet:text-M">
            サービス創設以来、リモートワークに注力してきました。場所を問わず働けるリモートワーク案件が豊富に揃っています。
          </p>
          <div className="text-XS text-member-gray-60 mt-2XS self-start">※リモートワーク比率は2025年1月末時点</div>
          <a href="/job_offers/remote" className="mt-2XL">
            <Button buttonType={isMobile ? 'SMALL' : 'DEFAULT'} link>
              リモートワーク案件特集を見る
            </Button>
          </a>
        </section>
      </section>
      <section className="pt-3XL desktop:pt-XL">
        <JobOffersSlider />
      </section>
      <section className="pt-3XL">
        <Accordion title="開発言語・スキルで案件を探す" defaultOpen={true} className={`bg-member-gray-0 ${styles.accordion}`}>
          <SkillSearchLinks />
        </Accordion>
        <Accordion title="職種で探す" className={`bg-member-gray-0 ${styles.accordion}`}>
          <CategorySearchLinks />
        </Accordion>
        <section className="flex flex-col gap-L pt-3XL items-center">
          <div className="text-S text-center tablet:text-M">
            その他にも稼働日数やこだわりなど{isMobile && <br />}様々な条件で案件を検索できます
          </div>
          <Link to="/job_offers">
            <Button buttonType={isMobile ? 'SMALL' : 'DEFAULT'} link>詳細検索をする</Button>
          </Link>
        </section>
      </section>
    </section>
  )
}
